import { Dispatch } from "redux";
import { ReportService } from "@Services/API/Reports";
import { actions } from "./index";

const { fetchAiUsageStart, fetchAiUsageSuccess, fetchAiUsageFailure } = actions;

const AiUsageActions = {
    fetchAiUsage: () => async (dispatch: Dispatch) => {
        dispatch(fetchAiUsageStart());

        try {
            const response = await ReportService.getAiUsage();
            dispatch(fetchAiUsageSuccess(response));
        } catch (error) {
            dispatch(fetchAiUsageFailure());
        }
    },
};

export default AiUsageActions;
